<template>
  <v-dialog
    v-model="$store.state.gsCommon_dialogShow.alertHtml"
    fullscreen
    hide-overlay
    persistent
    scrollable
  >
    <v-card tile>

      <!--  컨트롤러  -->
      <v-card-actions class="px-1">
        <v-btn
          @click="gmCommon_alertHtmlClose"
          elevation="0"
          text
        >
          <v-icon x-large>mdi-chevron-left</v-icon>
          <span class="font-weight-bold">뒤로가기</span>
        </v-btn>
      </v-card-actions>

      <!--  구분선  -->
      <v-divider class="grey"/>

      <!--  본문  -->
      <div class="c-card-text pa-3 grey lighten-3">
        <div class="pa-3 white c-html-wrap ql-editor" v-html="gcCommon_alertHtml"/>
        <div class="white pt-4 pb-8 text-center">
          <v-btn
            @click="onClick"
            elevation="0"
            color="blue"
            dark
            style="min-width: 160px"
          >
            <v-icon v-if="$store.state.gsCommon_alertHtmlUseTerm" class="ml-n2 mr-2">mdi-check</v-icon>
            확인
          </v-btn>
        </div>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CommonAlertHtml",
  methods: {
    onClick() {
      this.gmCommon_alertHtmlClose()
      if (this.$store.state.gsCommon_alertHtmlUseTerm) {
        this.$store.state.gsCommon_alertHtmlTermCheck = true
      }
    }
  }
}
</script>